import { NavLink, Outlet } from 'react-router-dom';

// Settings shell: a section list plus an <Outlet/> for the active section.
// The sub-nav is here from the start so adding a section is a route entry
// rather than a re-layout — and so the URL (/settings/tokens) already names
// its section instead of being the whole page.
//
// Reached from the sidebar user menu. Iteration 2.0 has no top nav, so nothing
// else links here.
const SECTIONS: ReadonlyArray<{ to: string; label: string; tone?: 'danger' }> = [
  { to: '/settings/tokens', label: 'Developer tokens' },
  // Last on purpose: the one irreversible action on this page sits below
  // everything else, not beside it.
  { to: '/settings/delete', label: 'Delete account', tone: 'danger' },
];

export default function SettingsPage() {
  return (
    <section className="settings">
      <h1 className="settings__title">Settings</h1>

      <div className="settings-layout">
        {/* No className *function* here on purpose: NavLink adds `active` itself
            regardless of whether className is a plain string, and the stylesheet
            targets that -- passing a string just layers `settings-nav__danger`
            alongside it for the one tab that needs a different color. */}
        <nav className="settings-nav" aria-label="Settings sections">
          {SECTIONS.map((section) => (
            <NavLink
              key={section.to}
              to={section.to}
              className={section.tone === 'danger' ? 'settings-nav__danger' : undefined}
            >
              {section.label}
            </NavLink>
          ))}
        </nav>

        <div className="settings-content">
          <Outlet />
        </div>
      </div>
    </section>
  );
}
